import { IconType } from "react-icons";
import { GoShieldLock } from "react-icons/go";
import { MdCardGiftcard, MdOutlineCreditCard } from "react-icons/md";

export interface GiftCardProgramItem {
  icon: IconType;
  title: string;
  description: string;
}

export const giftCardProgramData: GiftCardProgramItem[] = [
  {
    icon: MdCardGiftcard,
    title: "Participation",
    description:
      "While operators and locations must currently opt in to participate, the program becomes mandatory on July 1st, 2026. Only Visa and MasterCard gift cards issued through the GLC’s official platform are allowed for redemption. Other card types are not authorized.",
  },
  {
    icon: GoShieldLock,
    title: "Secure, Controlled Redemption",
    description:
      "Redemptions are strictly limited to approved gift cards and must follow GLC procedures. Cash or unapproved card options are not permitted.",
  },
  {
    icon: MdOutlineCreditCard,
    title: "Broad Spending Options",
    description:
      "These gift cards can be used anywhere Visa or Mastercard is accepted across the U.S.—with a few restrictions, such as no cash back, alcohol, tobacco, firearms, or recurring billing transactions.",
  },
];
